import { LANGUES, T } from '../i18n';
import { useLangue } from '../i18n/contexte';

/**
 * Choisir sa langue.
 *
 * Le choix vaut pour CET appareil et cette personne : l'agence garde sa langue
 * par défaut (Paramètres), et le gérant anglophone d'une agence française lit
 * son logiciel en anglais sans changer celui du comptoir.
 */
export function SelecteurLangue({ compact }: { compact?: boolean }) {
  const { langue, changer } = useLangue();
  return (
    <label className="selecteur-langue" title={T.commun.langue.changer}>
      {!compact && <span className="sourdine">{T.commun.langue.choisir}</span>}
      <select value={langue} aria-label={T.commun.langue.changer}
              onChange={(e) => changer(e.target.value as typeof langue)}>
        {LANGUES.map((l) => <option key={l.code} value={l.code}>{l.nom}</option>)}
      </select>
    </label>
  );
}
